import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { translate } from 'src/app/project/features/translate/translate';
import { EAdvancedFilterLogic } from '../../../models/advanced-filter-logic.enum';
import { TSearchAdvancedFilterOperator } from '../../../../points/point-search/point-search.consts';

@Component({
  selector: 'pp-advanced-filter-condition',
  templateUrl: './advanced-filter-condition.component.html',
  styleUrls: ['./advanced-filter-condition.component.scss'],
  standalone: false,
})
export class AdvancedFilterConditionComponent implements OnChanges {
  @Input() ppLogic: TSearchAdvancedFilterOperator;
  @Input() ppIndex: number;

  @Output() ppLogicChange = new EventEmitter<TSearchAdvancedFilterOperator>();

  logicOptions: TSelectOption[] = [
    {
      value: EAdvancedFilterLogic.AND,
      label: translate('and'),
    },
    {
      value: EAdvancedFilterLogic.OR,
      label: translate('or'),
    },
  ];

  selectedOption: TSelectOption;

  ngOnChanges(): void {
    this.findSelectedOption();
  }

  findSelectedOption(): void {
    if (this.ppLogic) {
      this.selectedOption = this.logicOptions.find((item) => item.value === this.ppLogic);
    } else {
      this.selectedOption = this.logicOptions[0];
    }
  }

  changeLogic(newLogic: TSelectOption): void {
    this.ppLogicChange.emit(newLogic.value as EAdvancedFilterLogic);
  }
}
